import { defineMessages } from 'react-intl';

type MessageKeys = 'collapse' | 'expand';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		collapse: {
			id: 'ai-mate.conversation-assistant-message-actions.expandable-cards.collapse',
			defaultMessage: 'Collapse',
			description: 'Label for button to collapse a single card',
		},
		expand: {
			id: 'ai-mate.conversation-assistant-message-actions.expandable-cards.expand',
			defaultMessage: 'Expand',
			description: 'Label for button to expand a single card',
		},
	});

export default message;
